<card-expanding
  [formGroup]="form"
  [valid]="productValidity.getCardStatusValidType(cardSection)"
  [expanded]="isExpanded"
  (onExpand)="saveLocalExpandedValue($event)"
>
  <span header-title>{{ title | translate}}</span>

  <div header-actions *requiredRights="[UserAction.ManageProducts]">
    <ng-container *ngIf="isOwnProduct">
      <locked-info *ngIf="!edit && locked" [locked]="locked"></locked-info>
      <ng-container *ngIf="!edit && !locked">
        <lxm-button
          type="beige"
          icon="edit"
          title="action.edit"
          (click)="toggleEdit()"
        ></lxm-button>
      </ng-container>
      <ng-container *ngIf="edit">
        <lxm-button
          type="grey"
          icon="back"
          label="action.cancel"
          (click)="toggleEdit()"
        >
        </lxm-button>
        <lxm-button
          type="beige"
          icon="save"
          label="action.save"
          [loading]="saveLoading"
          (click)="save()"
          buttonType="submit"
        ></lxm-button>
      </ng-container>
    </ng-container>
  </div>

  <div body>
    <div class="grid w-full grid-cols-1 gap-4 xl:grid-cols-2">
      <div class="flex flex-col">
        <form-field
          [readonly]="!edit"
          label="cards.products.product_storage_info.label.storage_conditions"
          description="cards.products.product_storage_info.label_description.storage_conditions"
          for="storageConditionsId"
          [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.StorageConditions, form.get('storageConditionsId').value)"
        >
          <lxm-select
            select
            for="storageConditionsId"
            class="w100p"
            value="id"
            labelField="translatedValue"
            [isTranslated]="true"
            [options]="storageConditionsOptions"
            [readonly]="!edit"
          >
          </lxm-select>
          <validation-errors for="storageConditionsId"></validation-errors>
        </form-field>

        <form-field
          [readonly]="!edit"
          label="cards.products.product_storage_info.label.shelf_life_marking"
          description="cards.products.product_storage_info.label_description.shelf_life_marking"
          for="shelfLifeMarkingId"
          [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.ShelfLifeMarking, form.get('shelfLifeMarkingId').value)"
        >
          <lxm-select
            select
            for="shelfLifeMarkingId"
            class="w100p"
            value="id"
            labelField="translatedValue"
            [isTranslated]="true"
            [options]="shelfLifeMarkingOptions"
            [readonly]="!edit"
          >
          </lxm-select>
          <validation-errors for="shelfLifeMarkingId"></validation-errors>
        </form-field>

        <form-field
          for="storageInfoIds"
          [readonly]="!edit"
          label="cards.products.product_storage_info.label.storage_info_clv"
          description="cards.products.product_storage_info.label_description.storage_info_clv"
          [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.StorageInfo, form.get('storageInfoIds').value)"
        >
          <lxm-select
            select
            for="storageInfoIds"
            value="id"
            labelField="translatedValue"
            [isTranslated]="true"
            [readonly]="!edit"
            [sortByLabel]="true"
            [searchable]="true"
            [multiple]="true"
            [options]="storageInfoOptions"
            class="w-full"
          >
          </lxm-select>
          <validation-errors for="storageInfoIds"></validation-errors>
        </form-field>

        <form-field
          for="batchMarkingType"
          [readonly]="!edit"
          label="cards.products.product_storage_info.label.batch_marking_type"
          description="cards.products.product_storage_info.label_description.batch_marking_type"
          [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.BatchMarkingType, form.get('batchMarkingType').value)"
        >
          <lxm-select
            select
            for="batchMarkingType"
            class="w100p"
            value="id"
            [options]="batchMarkingTypeOptions"
            [readonly]="!edit"
          >
          </lxm-select>
          <validation-errors for="batchMarkingType"></validation-errors>
        </form-field>

        <form-field
          for="batchMarkingFormat"
          [readonly]="!edit"
          label="cards.products.product_storage_info.label.batch_marking_format"
          description="cards.products.product_storage_info.label_description.batch_marking_format"
          [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.BatchMarkingFormat, form.get('batchMarkingFormat').value)"
        >
          <lxm-select
            select
            for="batchMarkingFormat"
            class="w100p"
            value="id"
            [options]="batchMarkingFormatOptions"
            [readonly]="!edit"
          >
          </lxm-select>
          <validation-errors for="batchMarkingFormat"></validation-errors>
        </form-field>

        <form-field
          for="batchMarkingElements"
          [readonly]="!edit"
          label="cards.products.product_storage_info.label.batch_marking_elements"
          description="cards.products.product_storage_info.label_description.batch_marking_elements"
          [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.BatchMarkingElements, form.get('batchMarkingElements').value)"
        >
          <lxm-select
            select
            for="batchMarkingElements"
            class="w100p"
            value="id"
            [multiple]="true"
            [options]="batchMarkingElementOptions"
            [readonly]="!edit"
          >
          </lxm-select>
          <validation-errors for="batchMarkingElements"></validation-errors>
        </form-field>
      </div>

      <div class="flex flex-col">
        <form-field
          [readonly]="!edit"
          label="cards.products.product_storage_info.label.temp_control_required"
          description="cards.products.product_storage_info.label_description.temp_control_required"
        >
          <slide-toggle
            toggle
            for="storageTemperatureControlRequired"
            [readonly]="!edit"
          ></slide-toggle>
          <validation-errors
            for="storageTemperatureControlRequired"
          ></validation-errors>
        </form-field>

        <form-field
          for="shelfLifeAfterOpeningInDays"
          type="input-text"
          description="cards.products.product_storage_info.label_description.shelf_life_open"
          [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.ShelfLifeAfterOpeningInHours, form.get('shelfLifeAfterOpeningInDays').value)"
          [readonly]="!edit"
          label="cards.products.product_storage_info.label.shelf_life_open"
        >
          <validation-errors
            for="shelfLifeAfterOpeningInDays"
          ></validation-errors>
        </form-field>

        <form-field
          for="paoMarkingInMonths"
          type="input-text"
          [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.PaoMarkingInMonths, form.get('paoMarkingInMonths').value)"
          [readonly]="!edit"
          label="cards.products.product_storage_info.label.PAO"
          description="cards.products.product_storage_info.label_description.PAO"
        >
          <validation-errors for="paoMarkingInMonths"></validation-errors>
        </form-field>

        <form-field
          for="storageMinTemp"
          type="input-text"
          [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.StorageMinTemp, form.get('storageMinTemp').value)"
          [readonly]="!edit"
          label="cards.products.product_storage_info.label.storage_temp_min"
          description="cards.products.product_storage_info.label_description.storage_temp_min"
        >
          <validation-errors for="storageMinTemp"></validation-errors>
        </form-field>

        <form-field
          for="storageMaxTemp"
          type="input-text"
          [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.StorageMaxTemp, form.get('storageMaxTemp').value)"
          [readonly]="!edit"
          label="cards.products.product_storage_info.label.storage_temp_max"
          description="cards.products.product_storage_info.label_description.storage_temp_max"
        >
          <validation-errors for="storageMaxTemp"></validation-errors>
        </form-field>
      </div>
    </div>

    <div class="separator"></div>

    <ng-container *ngIf="isOwnProduct">
      <card-section *ngIf="hasBuyerPim">
        <span header-title *ngIf="showExpirationsTitles">
          {{ 'cards.products.product_storage_info.label.storage_retailer_title'
          | translate }}
        </span>

        <product-retailer-expiry-list
          body
          for="locationExpirations"
          type="buyer"
          [readonly]="!edit"
          [expiryTargets]="expiryTargets"
          [singleRow]="true"
        >
        </product-retailer-expiry-list>
      </card-section>

      <card-section *ngIf="hasSellerPim">
        <span header-title *ngIf="showExpirationsTitles">
          {{ 'cards.products.product_storage_info.label.storage_supplier_title'
          | translate }}
        </span>

        <product-retailer-expiry-list
          body
          for="retailerExpirations"
          type="seller"
          [readonly]="!edit"
          [expiryTargets]="expiryTargets"
        >
        </product-retailer-expiry-list>
      </card-section>
    </ng-container>

    <card-section *ngIf="!isOwnProduct">
      <product-retailer-expiry-list
        for="retailerExpirations"
        type="market"
        [readonly]="true"
        [expiryTargets]="expiryTargets"
      >
      </product-retailer-expiry-list>
    </card-section>
  </div>
</card-expanding>
